<template>
    <form autocomplete="off" class="trax-form-with-icons" v-on:submit.prevent="search">

        <trax-ui-select icon="account_box" v-model="form.category" :options="category_select"
            :unselected="lang.polaris.settings.hdv_filter_all">
        </trax-ui-select>

        <trax-ui-datetime icon="event_available" :placeholder="lang.polaris.training.from_date"
            v-model="form.from" type="date"
        ></trax-ui-datetime>

        <trax-ui-datetime icon="event_available" :placeholder="lang.polaris.training.to_date"
            v-model="form.to" type="date"
        ></trax-ui-datetime>

        <!-- Submit buttons -->

        <div class="trax-form-actions text-right">
            <button type="button" class="btn btn-default btn-link" @click="reset"> {{ lang.polaris.form.reset }} </button>
            <button type="submit" class="btn btn-primary btn-round"> {{ lang.polaris.form.search }} </button>
        </div>

    </form>
</template>

<script>
    export default {
    
        props: {
            id: null,
            bus: null
        },
        
        data: function() {
            return {
                lang: lang,
                form: this.emptyForm(),
                category_select: [
                    { name: lang.polaris.settings.hdv_filter_paired, value: 'paired' },
                    { name: lang.polaris.settings.hdv_filter_unpaired, value: 'unpaired' },
                    { name: lang.polaris.settings.hdv_filter_alerts, value: 'alerts' },
                    { name: lang.polaris.settings.hdv_filter_warnings, value: 'warnings' },
                ]
            }
        },

        created: function() {
            this.bus.$on(this.id+'-filter-restore', data => {
                // Merge with the empty form to keep all the fields reactive.
                this.form = Object.assign(this.emptyForm(), data);
            })
        },

        methods: {

            // All the fields must be declared to stay reactive.
            emptyForm() {
                return {
                    category: null,
                    from: null,
                    to: null,
                }
            },

            search() {
                this.bus.$emit(this.id+'-filter', this.form);
                this.bus.$emit(this.id+'-search-close');
            },

            reset() {
                this.form = this.emptyForm();
                this.search();
            }
        }
            
    }
</script>
